import React from 'react';
import styled from 'styled-components';
import hiveBackground from 'images/background-hive.svg';
import emptyDashboardBackground from 'images/background-empty-dashboard.svg';
import { Flex } from './base/layout-components';

export const BACKGROUND_TYPES = {
  DEFAULT: 'DEFAULT',
  HIVE: 'HIVE',
  EMPTY_DASHBOARD: 'EMPTY_DASHBOARD'
};

export const BACKGROUND_TYPE_TO_BACKGROUND_IMG = {
  HIVE: hiveBackground,
  EMPTY_DASHBOARD: emptyDashboardBackground
};

const BackgroundWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const StyledBackground = styled(Flex)`
  background-size: cover;
`;

export const BackgroundContainer = ({
  children,
  type = BACKGROUND_TYPES.DEFAULT,
  ...otherProps
}) => {
  const imgSrc = BACKGROUND_TYPE_TO_BACKGROUND_IMG[type];

  return (
    <StyledBackground
      data-testid='background'
      width='100%'
      height='100vh'
      {...(imgSrc && { background: `url(${imgSrc})` })}
      {...otherProps}
    >
      {children}
    </StyledBackground>
  );
};

const Background = ({ styles, type = BACKGROUND_TYPES.DEFAULT }) => {
  const imgSrc = BACKGROUND_TYPE_TO_BACKGROUND_IMG[type];
  return (
    <>
      <BackgroundWrapper style={styles} />
      {imgSrc && (
        <img
          src={imgSrc}
          alt=''
          style={{ width: '100%', height: '100%', backgroundColor: 'white' }}
        />
      )}
    </>
  );
};

export default Background;
